const BinanceFetch = async (endpoint: string, options: RequestInit = {}) => {
  const baseURL = process.env.NEXT_PUBLIC_FUTU_URL as string

  const url = `${baseURL}${endpoint}`

  // Fetch 요청 기본 설정
  const fetchOptions: RequestInit = {
    method: options.method || 'GET',

    headers: {
      ...options.headers,
    },

    ...options,
  }

  // Fetch 요청 실행
  try {
    const response = await fetch(url, fetchOptions)

    // 응답을 텍스트로 먼저 읽고 JSON 파싱 시도
    const responseText = await response.text();

    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      // JSON 파싱 실패 시 HTML 응답인지 확인
      if (responseText.trim().startsWith('<!DOCTYPE') || responseText.trim().startsWith('<html')) {
        console.error("Expected JSON but received HTML:", responseText.substring(0, 200));
        throw new Error('Invalid response format: received HTML instead of JSON');
      }
      // 다른 파싱 오류는 그대로 던짐
      console.error("JSON parse error:", parseError, "Response:", responseText.substring(0, 200));
      throw parseError;
    }

    return data;
  } catch (error) {
    throw error;
  }
}

export { BinanceFetch };